module.exports = __webpack_public_path__ + "img/bluesky3100_18.3b38cdb1.jpg";